import React from "react";
import { SiGmail } from "react-icons/si";
import { BsGithub, BsStackOverflow } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://stackoverflow.com/users/18533183/ava">
          <BsStackOverflow />
        </a>
      </div>
      <div>
        <a href="https://github.com/darkpsinight">
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="mailto:barhoumi.ragheb@gmail.com">
          <SiGmail />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
